/**
 * @file In-app Event 应用内事件数据
 */
import {
  integerValueFormatter,
  moneyFormatterWithUnit,
  percentCellFormatter,
  durationFormatter,
} from 'src/const/statistics/formatters';
import { EVENT_ATTRIBUTE_SKAN } from 'src/const/statistics/metrics-emun';

// 当前在 Reporting 页面
const isInReportingModule = () => window.location.href.includes('reporting');

export const EnumInAppEventSkanData = [
  {
    i18nPath: 'list_skan_event_app_install', // NOTE: 非对回的active也要保留
    key: 'skan_event_app_install', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_active',
    children: [
      {
        i18nPath: 'list_skan_event_app_install_unique_count', //
        key: 'skan_active', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_app_install_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_app_install_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_app_install_unique_cost', //
        key: 'cost_per_skan_active', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_app_install_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_app_install_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_app_install_withheld_unique_count', // App Install (SKAN Privacy Withhelds)
    key: 'skan_event_app_install_withheld', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.skan_event_app_install_withheld_unique_count',
    hide: () => isInReportingModule(),
    children: [
      {
        i18nPath: 'list_skan_event_app_install_withheld_unique_count', //
        key: 'skan_active_withheld', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_app_install_withheld_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_app_install_withheld_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_app_install_withheld_unique_count', // App Install (SKAN Privacy Withhelds)
    key: 'skan_active_withheld', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.skan_event_app_install_withheld_unique_count',
    formatter: integerValueFormatter, // 格式化表格数据
    hide: () => !isInReportingModule(),
    children: [
      {
        i18nPath: 'list_skan_event_app_install_withheld_unique_count', //
        key: 'skan_active_withheld', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_app_install_withheld_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_app_install_withheld_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_registration', // NOTE: 非对回的active也要保留
    key: 'skan_event_registration', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_active_register',
    children: [
      {
        i18nPath: 'list_skan_event_registration_unique_count', //
        key: 'skan_active_register', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_registration_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_registration_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_registration_unique_cost', //
        key: 'cost_per_skan_active_register', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_registration_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_registration_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_registration_unique_rate', //
        key: 'skan_active_register_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_registration_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_registration_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_registration_each_count', //
        key: 'skan_repetitive_active_register', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_registration_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_registration_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_registration_each_cost', //
        key: 'cost_per_skan_repetitive_active_register', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_registration_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_registration_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_purchase', // NOTE: 非对回的active也要保留
    key: 'skan_event_purchase', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_active_pay',
    children: [
      {
        i18nPath: 'list_skan_event_purchase_unique_count', //
        key: 'skan_active_pay', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_purchase_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_purchase_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_purchase_unique_cost', //
        key: 'cost_per_skan_active_pay', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_purchase_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_purchase_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_purchase_unique_rate', //
        key: 'skan_active_pay_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_purchase_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_purchase_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_purchase_each_count', //
        key: 'skan_repetitive_active_pay', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_purchase_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_purchase_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_purchase_each_cost', //
        key: 'cost_per_skan_repetitive_active_pay', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_purchase_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_purchase_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_purchase_each_value', //
        key: 'skan_total_repetitive_active_pay_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_purchase_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_purchase_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_roas', //
        key: 'skan_total_repetitive_active_pay_roas', // {metric}
        hint: 'campaign_hover_stat_data.skan_total_repetitive_active_pay_roas',
        hoverKey: 'campaign_hover_stat_data.skan_total_repetitive_active_pay_roas',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: durationFormatter, // 格式化表格数据
        hide: () => !isInReportingModule(),
      },
    ],
  },
  {
    i18nPath: 'common_metric_set_skan_total_repetitive_active_pay_roas', // NOTE: 非对回的active也要保留
    key: 'skan_event_roas', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.skan_total_repetitive_active_pay_roas',
    hide: () => isInReportingModule(),
    children: [
      {
        i18nPath: 'list_skan_event_roas', //
        key: 'skan_total_repetitive_active_pay_roas', // {metric}
        hint: 'campaign_hover_stat_data.skan_total_repetitive_active_pay_roas',
        hoverKey: 'campaign_hover_stat_data.skan_total_repetitive_active_pay_roas',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: durationFormatter, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_add_to_cart', // NOTE: 非对回的active也要保留
    key: 'skan_event_add_to_cart', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_cart',
    children: [
      {
        i18nPath: 'list_skan_event_add_to_cart_unique_count', //
        key: 'skan_in_app_cart', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_to_cart_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_to_cart_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_to_cart_unique_cost', //
        key: 'cost_per_skan_in_app_cart', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_to_cart_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_to_cart_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_to_cart_unique_rate', //
        key: 'skan_in_app_cart_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_to_cart_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_to_cart_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_to_cart_each_count', //
        key: 'skan_repetitive_in_app_cart', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_to_cart_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_to_cart_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_to_cart_each_cost', //
        key: 'cost_per_skan_repetitive_in_app_cart', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_to_cart_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_to_cart_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_to_cart_each_value', //
        key: 'skan_total_repetitive_in_app_cart_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_to_cart_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_to_cart_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_checkout', // NOTE: 非对回的active也要保留
    key: 'skan_event_checkout', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_order',
    children: [
      {
        i18nPath: 'list_skan_event_checkout_unique_count', //
        key: 'skan_in_app_order', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_checkout_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_checkout_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_checkout_unique_cost', //
        key: 'cost_per_skan_in_app_order', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_checkout_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_checkout_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_checkout_unique_rate', //
        key: 'skan_in_app_order_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_checkout_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_checkout_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_checkout_each_count', //
        key: 'skan_repetitive_in_app_order', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_checkout_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_checkout_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_checkout_each_cost', //
        key: 'cost_per_skan_repetitive_in_app_order', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_checkout_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_checkout_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_checkout_each_value', //
        key: 'skan_total_repetitive_in_app_order_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_checkout_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_checkout_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_view_content', // NOTE: 非对回的active也要保留
    key: 'skan_event_view_content', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_detail_uv',
    children: [
      {
        i18nPath: 'list_skan_event_view_content_unique_count', //
        key: 'skan_in_app_detail_uv', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_view_content_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_view_content_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_view_content_unique_cost', //
        key: 'cost_per_skan_in_app_detail_uv', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_view_content_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_view_content_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_view_content_unique_rate', //
        key: 'skan_in_app_detail_uv_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_view_content_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_view_content_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_view_content_each_count', //
        key: 'skan_repetitive_in_app_detail_uv', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_view_content_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_view_content_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_view_content_each_cost', //
        key: 'cost_per_skan_repetitive_in_app_detail_uv', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_view_content_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_view_content_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_view_content_each_value', //
        key: 'skan_total_repetitive_in_app_detail_uv_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_view_content_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_view_content_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_add_payment_info', // NOTE: 非对回的active也要保留
    key: 'skan_event_add_payment_info', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_add_payment_info',
    children: [
      {
        i18nPath: 'list_skan_event_add_payment_info_unique_count', //
        key: 'skan_add_payment_info', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_payment_info_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_payment_info_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_payment_info_unique_cost', //
        key: 'cost_per_skan_add_payment_info', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_payment_info_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_payment_info_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_payment_info_unique_rate', //
        key: 'skan_add_payment_info_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_payment_info_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_payment_info_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_payment_info_each_count', //
        key: 'skan_repetitive_add_payment_info', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_payment_info_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_payment_info_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_payment_info_each_cost', //
        key: 'cost_per_skan_repetitive_add_payment_info', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_payment_info_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_payment_info_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_add_wishlist', // NOTE: 非对回的active也要保留
    key: 'skan_event_add_wishlist', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_add_to_wishlist',
    children: [
      {
        i18nPath: 'list_skan_event_add_wishlist_unique_count', //
        key: 'skan_add_to_wishlist', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_wishlist_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_wishlist_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_wishlist_unique_cost', //
        key: 'cost_per_skan_add_to_wishlist', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_wishlist_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_wishlist_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_wishlist_unique_rate', //
        key: 'skan_add_to_wishlist_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_wishlist_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_wishlist_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_wishlist_each_count', //
        key: 'skan_repetitive_add_to_wishlist', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_wishlist_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_wishlist_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_wishlist_each_cost', //
        key: 'cost_per_skan_repetitive_add_to_wishlist', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_wishlist_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_wishlist_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_add_wishlist_each_value', //
        key: 'skan_total_repetitive_add_to_wishlist_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_add_wishlist_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_add_wishlist_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_launch_app', // NOTE: 非对回的active也要保留
    key: 'skan_event_launch_app', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_launch_app',
    children: [
      {
        i18nPath: 'list_skan_event_launch_app_unique_count', //
        key: 'skan_launch_app', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_launch_app_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_launch_app_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_launch_app_unique_cost', //
        key: 'cost_per_skan_launch_app', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_launch_app_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_launch_app_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_launch_app_unique_rate', //
        key: 'skan_launch_app_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_launch_app_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_launch_app_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_launch_app_each_count', //
        key: 'skan_repetitive_launch_app', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_launch_app_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_launch_app_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_launch_app_each_cost', //
        key: 'cost_per_skan_repetitive_launch_app', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_launch_app_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_launch_app_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_complete_tutorial', // NOTE: 非对回的active也要保留
    key: 'skan_event_complete_tutorial', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_complete_tutorial',
    children: [
      {
        i18nPath: 'list_skan_event_complete_tutorial_unique_count', //
        key: 'skan_complete_tutorial', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_complete_tutorial_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_complete_tutorial_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_complete_tutorial_unique_cost', //
        key: 'cost_per_skan_complete_tutorial', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_complete_tutorial_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_complete_tutorial_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_complete_tutorial_unique_rate', //
        key: 'skan_complete_tutorial_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_complete_tutorial_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_complete_tutorial_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_complete_tutorial_each_count', //
        key: 'skan_repetitive_complete_tutorial', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_complete_tutorial_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_complete_tutorial_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_complete_tutorial_each_cost', //
        key: 'cost_per_skan_repetitive_complete_tutorial', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_complete_tutorial_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_complete_tutorial_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_complete_tutorial_each_value', //
        key: 'skan_total_repetitive_complete_tutorial_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_complete_tutorial_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_complete_tutorial_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_create_group', // NOTE: 非对回的active也要保留
    key: 'skan_event_create_group', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_create_group',
    children: [
      {
        i18nPath: 'list_skan_event_create_group_unique_count', //
        key: 'skan_create_group', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_group_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_group_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_group_unique_cost', //
        key: 'cost_per_skan_create_group', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_group_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_group_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_group_unique_rate', //
        key: 'skan_create_group_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_group_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_group_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_group_each_count', //
        key: 'skan_repetitive_create_group', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_group_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_group_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_group_each_cost', //
        key: 'cost_per_skan_repetitive_create_group', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_group_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_group_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_group_each_value', //
        key: 'skan_total_repetitive_create_group_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_group_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_group_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_join_group', // NOTE: 非对回的active也要保留
    key: 'skan_event_join_group', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_join_group',
    children: [
      {
        i18nPath: 'list_skan_event_join_group_unique_count', //
        key: 'skan_join_group', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_join_group_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_join_group_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_join_group_unique_cost', //
        key: 'cost_per_skan_join_group', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_join_group_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_join_group_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_join_group_unique_rate', //
        key: 'skan_join_group_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_join_group_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_join_group_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_join_group_each_count', //
        key: 'skan_repetitive_join_group', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_join_group_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_join_group_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_join_group_each_cost', //
        key: 'cost_per_skan_repetitive_join_group', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_join_group_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_join_group_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_join_group_each_value', //
        key: 'skan_total_repetitive_join_group_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_join_group_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_join_group_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_create_role', // NOTE: 非对回的active也要保留
    key: 'skan_event_create_role', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_create_gamerole',
    children: [
      {
        i18nPath: 'list_skan_event_create_role_unique_count', //
        key: 'skan_create_gamerole', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_role_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_role_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_role_unique_cost', //
        key: 'cost_per_skan_create_gamerole', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_role_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_role_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_role_unique_rate', //
        key: 'skan_create_gamerole_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_role_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_role_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_role_each_count', //
        key: 'skan_repetitive_create_gamerole', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_role_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_role_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_role_each_cost', //
        key: 'cost_per_skan_repetitive_create_gamerole', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_role_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_role_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_create_role_each_value', //
        key: 'skan_total_repetitive_create_gamerole_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_create_role_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_create_role_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_spend_credit', // NOTE: 非对回的active也要保留
    key: 'skan_event_spend_credit', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_spend_credits',
    children: [
      {
        i18nPath: 'list_skan_event_spend_credit_unique_count', //
        key: 'skan_spend_credits', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_spend_credit_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_spend_credit_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_spend_credit_unique_cost', //
        key: 'cost_per_skan_spend_credits', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_spend_credit_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_spend_credit_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_spend_credit_unique_rate', //
        key: 'skan_spend_credits_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_spend_credit_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_spend_credit_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_spend_credit_each_count', //
        key: 'skan_repetitive_spend_credits', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_spend_credit_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_spend_credit_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_spend_credit_each_cost', //
        key: 'cost_per_skan_repetitive_spend_credits', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_spend_credit_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_spend_credit_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_spend_credit_each_value', //
        key: 'skan_total_repetitive_spend_credits_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_spend_credit_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_spend_credit_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_achieve_level', // NOTE: 非对回的active也要保留
    key: 'skan_event_achieve_level', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_update_level',
    children: [
      {
        i18nPath: 'list_skan_event_achieve_level_unique_count', //
        key: 'skan_update_level', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_achieve_level_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_achieve_level_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_achieve_level_unique_cost', //
        key: 'cost_per_skan_update_level', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_achieve_level_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_achieve_level_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_achieve_level_unique_rate', //
        key: 'skan_update_level_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_achieve_level_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_achieve_level_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_achieve_level_each_count', //
        key: 'skan_repetitive_update_level', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_achieve_level_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_achieve_level_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_achieve_level_each_cost', //
        key: 'cost_per_skan_repetitive_update_level', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_achieve_level_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_achieve_level_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_achieve_level_each_value', //
        key: 'skan_total_repetitive_update_level_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_achieve_level_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_achieve_level_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_unlock_achievement', // NOTE: 非对回的active也要保留
    key: 'skan_event_unlock_achievement', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_unlock_achievement',
    children: [
      {
        i18nPath: 'list_skan_event_unlock_achievement_unique_count', //
        key: 'skan_unlock_achievement', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_unlock_achievement_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_unlock_achievement_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_unlock_achievement_unique_cost', //
        key: 'cost_per_skan_unlock_achievement', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_unlock_achievement_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_unlock_achievement_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_unlock_achievement_unique_rate', //
        key: 'skan_unlock_achievement_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_unlock_achievement_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_unlock_achievement_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_unlock_achievement_each_count', //
        key: 'skan_repetitive_unlock_achievement', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_unlock_achievement_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_unlock_achievement_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_unlock_achievement_each_cost', //
        key: 'cost_per_skan_repetitive_unlock_achievement', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_unlock_achievement_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_unlock_achievement_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_unlock_achievement_each_value', //
        key: 'skan_total_repetitive_unlock_achievement_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_unlock_achievement_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_unlock_achievement_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_generate_lead', // NOTE: 非对回的active也要保留
    key: 'skan_event_generate_lead', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_sales_lead',
    children: [
      {
        i18nPath: 'list_skan_event_generate_lead_unique_count', //
        key: 'skan_sales_lead', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_generate_lead_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_generate_lead_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_generate_lead_unique_cost', //
        key: 'cost_per_skan_sales_lead', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_generate_lead_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_generate_lead_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_generate_lead_unique_rate', //
        key: 'skan_sales_lead_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_generate_lead_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_generate_lead_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_generate_lead_each_count', //
        key: 'skan_repetitive_sales_lead', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_generate_lead_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_generate_lead_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_generate_lead_each_cost', //
        key: 'cost_per_skan_repetitive_sales_lead', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_generate_lead_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_generate_lead_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_generate_lead_each_value', //
        key: 'skan_total_repetitive_sales_lead_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_generate_lead_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_generate_lead_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_in_app_ad_click', // NOTE: 非对回的active也要保留
    key: 'skan_event_in_app_ad_click', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_ad_click',
    children: [
      {
        i18nPath: 'list_skan_event_in_app_ad_click_unique_count', //
        key: 'skan_in_app_ad_click', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_click_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_click_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_click_unique_cost', //
        key: 'cost_per_skan_in_app_ad_click', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_click_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_click_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_click_unique_rate', //
        key: 'skan_in_app_ad_click_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_click_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_click_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_click_each_count', //
        key: 'skan_repetitive_in_app_ad_click', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_click_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_click_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_click_each_cost', //
        key: 'cost_per_skan_repetitive_in_app_ad_click', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_click_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_click_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_click_each_value', //
        key: 'skan_total_repetitive_in_app_ad_click_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_click_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_click_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_in_app_ad_impr', // NOTE: 非对回的active也要保留
    key: 'skan_event_in_app_ad_impr', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_ad_impr',
    children: [
      {
        i18nPath: 'list_skan_event_in_app_ad_impr_unique_count', //
        key: 'skan_in_app_ad_impr', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_impr_unique_cost', //
        key: 'cost_per_skan_in_app_ad_impr', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_impr_unique_rate', //
        key: 'skan_in_app_ad_impr_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_impr_each_count', //
        key: 'skan_repetitive_in_app_ad_impr', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_impr_each_cost', //
        key: 'cost_per_skan_repetitive_in_app_ad_impr', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_in_app_ad_impr_each_value', //
        key: 'skan_total_repetitive_in_app_ad_impr_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_in_app_ad_impr_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_loan_apply', // NOTE: 非对回的active也要保留
    key: 'skan_event_loan_apply', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_loan_apply',
    children: [
      {
        i18nPath: 'list_skan_event_loan_apply_unique_count', //
        key: 'skan_loan_apply', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_apply_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_apply_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_apply_unique_cost', //
        key: 'cost_per_skan_loan_apply', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_apply_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_apply_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_apply_unique_rate', //
        key: 'skan_loan_apply_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_apply_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_apply_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_apply_each_count', //
        key: 'skan_repetitive_loan_apply', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_apply_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_apply_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_apply_each_cost', //
        key: 'cost_per_skan_repetitive_loan_apply', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_apply_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_apply_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_loan_approval', // NOTE: 非对回的active也要保留
    key: 'skan_event_loan_approval', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_loan_credit',
    children: [
      {
        i18nPath: 'list_skan_event_loan_approval_unique_count', //
        key: 'skan_loan_credit', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_approval_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_approval_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_approval_unique_cost', //
        key: 'cost_per_skan_loan_credit', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_approval_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_approval_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_approval_unique_rate', //
        key: 'skan_loan_credit_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_approval_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_approval_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_approval_each_count', //
        key: 'skan_repetitive_loan_credit', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_approval_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_approval_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_approval_each_cost', //
        key: 'cost_per_skan_repetitive_loan_credit', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_approval_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_approval_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_loan_disbursement', // NOTE: 非对回的active也要保留
    key: 'skan_event_loan_disbursement', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_loan_completion',
    children: [
      {
        i18nPath: 'list_skan_event_loan_disbursement_unique_count', //
        key: 'skan_loan_completion', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_disbursement_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_disbursement_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_disbursement_unique_cost', //
        key: 'cost_per_skan_loan_completion', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_disbursement_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_disbursement_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_disbursement_unique_rate', //
        key: 'skan_loan_completion_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_disbursement_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_disbursement_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_disbursement_each_count', //
        key: 'skan_repetitive_loan_completion', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_disbursement_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_disbursement_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_loan_disbursement_each_cost', //
        key: 'cost_per_skan_repetitive_loan_completion', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_loan_disbursement_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_loan_disbursement_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_login', // NOTE: 非对回的active也要保留
    key: 'skan_event_login', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_login',
    children: [
      {
        i18nPath: 'list_skan_event_login_unique_count', //
        key: 'skan_login', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_login_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_login_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_login_unique_cost', //
        key: 'cost_per_skan_login', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_login_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_login_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_login_unique_rate', //
        key: 'skan_login_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_login_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_login_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_login_each_count', //
        key: 'skan_repetitive_login', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_login_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_login_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_login_each_cost', //
        key: 'cost_per_skan_repetitive_login', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_login_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_login_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_rate', // NOTE: 非对回的active也要保留
    key: 'skan_event_rate', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_rate',
    children: [
      {
        i18nPath: 'list_skan_event_rate_unique_count', //
        key: 'skan_rate', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_rate_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_rate_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_rate_unique_cost', //
        key: 'cost_per_skan_rate', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_rate_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_rate_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_rate_unique_rate', //
        key: 'skan_rate_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_rate_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_rate_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_rate_each_count', //
        key: 'skan_repetitive_rate', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_rate_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_rate_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_rate_each_cost', //
        key: 'cost_per_skan_repetitive_rate', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_rate_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_rate_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_rate_each_value', //
        key: 'skan_total_repetitive_rate_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_rate_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_rate_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_search', // NOTE: 非对回的active也要保留
    key: 'skan_event_search', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_search',
    children: [
      {
        i18nPath: 'list_skan_event_search_unique_count', //
        key: 'skan_search', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_search_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_search_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_search_unique_cost', //
        key: 'cost_per_skan_search', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_search_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_search_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_search_unique_rate', //
        key: 'skan_search_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_search_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_search_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_search_each_count', //
        key: 'skan_repetitive_search', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_search_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_search_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_search_each_cost', //
        key: 'cost_per_skan_repetitive_search', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_search_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_search_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_start_trial', // NOTE: 非对回的active也要保留
    key: 'skan_event_start_trial', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_start_trial',
    children: [
      {
        i18nPath: 'list_skan_event_start_trial_unique_count', //
        key: 'skan_start_trial', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_start_trial_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_start_trial_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_start_trial_unique_cost', //
        key: 'cost_per_skan_start_trial', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_start_trial_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_start_trial_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_start_trial_unique_rate', //
        key: 'skan_start_trial_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_start_trial_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_start_trial_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_start_trial_each_count', //
        key: 'skan_repetitive_start_trial', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_start_trial_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_start_trial_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_start_trial_each_cost', //
        key: 'cost_per_skan_repetitive_start_trial', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_start_trial_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_start_trial_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'list_skan_event_subscribe', // NOTE: 非对回的active也要保留
    key: 'skan_event_subscribe', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_subscribe',
    children: [
      {
        i18nPath: 'list_skan_event_subscribe_unique_count', //
        key: 'skan_subscribe', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_subscribe_unique_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_subscribe_unique_count',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_subscribe_unique_cost', //
        key: 'cost_per_skan_subscribe', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_subscribe_unique_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_subscribe_unique_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_subscribe_unique_rate', //
        key: 'skan_subscribe_per_install', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_subscribe_unique_rate',
        hoverKey: 'campaign_hover_stat_data.skan_event_subscribe_unique_rate',
        attribute: EVENT_ATTRIBUTE_SKAN.UNIQUE_CONVERSION_RATE.value,
        sortable: true,
        formatter: percentCellFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_subscribe_each_count', //
        key: 'skan_repetitive_subscribe', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_subscribe_each_count',
        hoverKey: 'campaign_hover_stat_data.skan_event_subscribe_each_count',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_EVENTS.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_subscribe_each_cost', //
        key: 'cost_per_skan_repetitive_subscribe', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_subscribe_each_cost',
        hoverKey: 'campaign_hover_stat_data.skan_event_subscribe_each_cost',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CPA.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
      {
        i18nPath: 'list_skan_event_subscribe_each_value', //
        key: 'skan_total_repetitive_subscribe_value', // {metric}
        hint: 'campaign_hover_stat_data.skan_event_subscribe_each_value',
        hoverKey: 'campaign_hover_stat_data.skan_event_subscribe_each_value',
        attribute: EVENT_ATTRIBUTE_SKAN.TOTAL_CONVERSION_RATE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit, // 格式化表格数据
      },
    ],
  },
];
